import styled from 'styled-components';

const SidebarWrapper = styled.div`
  // width: 800px;
  background: #1E1E1E;
  // text-align: center;
  padding: 80px;
  @media only screen and (max-width: 1024px) {
    width: auto;
    padding: 60px 32px;
  }
`;

export default SidebarWrapper;